
export { default as document } from "./main2.js"
export { default as window } from "./main3.js"